import React, { useEffect } from "react";
import MenteeDashboard from "../../Pages/MenteeDashboard";
import MentorDashboard1 from "../../Pages/MentorDashboard1";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";

const Index = (props) => {

  const { title } = props;
  const userInfo = useSelector((state) => state.userInfo || {});

  useEffect(() => {
    document.title = title;
  }, [title]);

  if (userInfo.role_id === "Mentor") {
    return (
      <MentorDashboard1 />
    );
  } else {
    return (
      <MenteeDashboard />
    );
  }
};
Index.propTypes = {
  title: PropTypes.string,
};

export default Index;
